import theme from 'assets/theme/theme';
import LoginBG from 'assets/img/loginBackground.jpg';

const styles = () => ({
    loginBackground: {
        display: 'flex',
        height: '100%',
        width: '100%',
        position: 'fixed',
        top: 0,
        right: 0,
        background: `url(${LoginBG}) no-repeat fixed`,
        flexDirection: 'row-reverse',
    },
    loginDiv: {
        display: 'flex',
        height: '100%',
        width: '30%',
        backgroundColor: 'white',
        justifyContent: 'center',
        flexWrap: 'wrap',
        minWidth: 320,
        minHeight: 800,
    },
    loginContainer: {
        display: 'flex',
        marginTop: '10%',
        height: '90%',
        width: '80%',
        flexDirection: 'column',
    },
    loginForm: {
        display: 'flex',
        width: '100%',
        height: '50%',
        flexDirection: 'column',
    },
    loginTitleDiv: {
        display: 'flex',
        width: '100%',
        height: '25%',
    },
    loginTitle: {
        fontFamily: 'Source Sans Pro, sans-serif',
        fontWeight: 'bold',
    },
    office: {
        color: theme.palette.green.light,
    },
    loginSubtitle: {
        color: theme.palette.green.dark,
        flex: 1,
        marginLeft: theme.spacing(11.25),
        marginTop: theme.spacing(-0.875),
        fontSize: 20,
    },
    loginInputDiv: {
        display: 'flex',
        width: '100%',
        height: '30%',
        flexDirection: 'column',
    },
    inputTitle: {
        display: 'flex',
        width: '100%',
        fontFamily: 'Source Sans Pro, sans-serif',
    },
    connectionButtonDiv: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
    },
    connectionButton: {
        fontFamily: 'Source Sans Pro, sans-serif',
        fontSize: 20,
    },
    footerLogoDiv: {
        display: 'flex',
        width: '100%',
        height: '50%',
        flexDirection: 'column',
    },
    footerLogo: {
        display: 'flex',
        width: '100%',
        marginTop: '50%',
    },
    '@media (max-height: 870px)': {
        footerLogo: {
            marginTop: '20%',
        },
    }
});

export default styles;
